export const GET_MUNICIPALITIES_REQUEST = "GET_MUNICIPALITIES_REQUEST";
export const GET_MUNICIPALITIES_SUCCESS = "GET_MUNICIPALITIES_SUCCESS";
export const GET_MUNICIPALITIES_FAIL = "GET_MUNICIPALITIES_FAIL";
export const GET_MUNICIPALITIES_RESET = "GET_MUNICIPALITIES_RESET";